import { StorageContainer } from '@@partner:types:app'
import type {
  CommonSort,
  NestedFilter,
  CommonPager,
  PageInfo
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'

export interface AllStorageContainersQuery {
  allStorageContainers: {
    edges: StorageContainer[]
    pageInfo: PageInfo
  }
}

export interface AllStorageContainersVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager?: CommonPager
}

export const GQL_QUERY_ALL_STORAGE_CONTAINERS = gql`
  query allStorageContainers(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allStorageContainers(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        id
        container_id
        size
        type
        description
        is_active
        created_at
        updated_at
        ordersCount
        activeOrdersCount
        displayName
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export function useFetchAllStorageContainers (variables: AllStorageContainersVariables = {}) {
  return useQuery<AllStorageContainersQuery, AllStorageContainersVariables>(
    GQL_QUERY_ALL_STORAGE_CONTAINERS,
    {
      variables
    }
  )
}
